/*
 * File: d:\projects\AutoFiFront\public\BrandSvg\FIAT.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:08:00 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function FIAT(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M215.05,340.16l12.96,400.11h62.97l-1.38-165.92h52.81v-51.72h-52.81l.2-130.19h68.94l-.37-52.28H215.05Zm168.21,0l7.97,400.11h65.03l1.32-400.1h-74.32Zm304.86,0v50.47h51.36l-1.48,349.64h62.91l13.36-349.69h50.94l-.39-50.41h-176.72Zm-132.48,185.18l.71-135.9h36.32c16.46,30.26,27.04,70.29,35.33,135.9h-72.35Zm-58.01,214.92h60.2l.67-165.44h72.13c5.67,29.2,7.06,119.34,7.39,165.44h58.4c5.53-204.26-11.59-319.71-58.88-400.09h-145.42l5.51,400.09Z"/>
        </svg>
    );
}

export default FIAT;
